import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface FiltersState {
    city: string;
    firstTime: boolean;
    date: { startDate: number; endDate: number };
}

const name = 'tab';
const initialState: FiltersState = createInitialState();
const reducers = createReducers();
const slice = createSlice({ name, initialState, reducers });

export const filtersActions = { ...slice.actions };
export const filtersReducer = slice.reducer;

function createInitialState(): FiltersState {
    return {
        city: '',
        firstTime: true,
        date: { startDate: 0, endDate: 0 }
    };
}

function createReducers() {
    return { setActiveCity, setDate, setFirstTime };

    function setActiveCity(state: FiltersState, action: PayloadAction<string>) {
        state.city = action.payload;
    }

    function setDate(state: FiltersState, action: PayloadAction<{ startDate: number; endDate: number }>) {
        state.date = { ...state.date, ...action.payload };
    }

    function setFirstTime(state: FiltersState, action: PayloadAction<boolean>) {
        state.firstTime = action.payload;
    }
}

